import React from "react";
import { Application } from "@src/Interfaces/Entity/ApplicationLink";
import {
  STGrid,
  STCard,
  STCardActionArea,
  STCardMedia,
  STCardContent,
  STTypography,
} from "./styles";

export interface IItemAppsProps extends Application {
  sameApp?: boolean;
}

export default class ItemApps extends React.Component<IItemAppsProps> {
  render() {
    return (
      <STGrid
        container
        justify="flex-start"
        item
        xs={4} sm={4} md={3} lg={this.props.sameApp ? 3 : 1}
        onClick={()=> window.open(this.props.url, "_blank")}
      >
        <STCard>
          <STCardActionArea>
            <STCardMedia
              image={this.props.imageUrl}
              title={this.props.title}
            />
            <STCardContent>
              <STTypography gutterBottom variant="h5" component="h2" align="center">
                {this.props.title}
              </STTypography>
            </STCardContent>
          </STCardActionArea>
        </STCard>
      </STGrid>
    );
  }
}
